import styled from 'styled-components';

export const LoginContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  > div {
    max-width: 500px;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  form {
    width: 100%;
  }
  .Alert {
    margin-bottom: 24px;
  }
  > svg {
    margin-bottom: 32px;
  }
  button {
    display: flex;
    width: 100%;
    > div {
      justify-content: space-between;
    }
  }
`;

export const Title = styled.h1`
  color: var(--color-black-primary);
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  margin-bottom: 12px;
  width: 100%;
  text-align: center;
  margin-bottom: 28px;
`;

export const RecoverPasswordButton = styled.button`
  border: none;
  background: transparent;
  color: var(--color-blue-primary);
  font-size: 14px;
  margin-bottom: 20px;
  justify-content: flex-end;
`;

export const ResetInfo = styled.p`
  color: var(--color-green-100);
  font-size: 14px;
  margin-bottom: 20px;
  width: 100%;
`;

export const SubmitButtonWrapper = styled.div`
  width: 100%;
  margin-top: 32px;
`;
